export const forBusiness_email_audience = [
	{
		icon: '🤘',
		title: 'audienceData_title1',
		subtitle: 'audienceData_subtitle1',
	},
	{
		icon: '✨',
		title: 'audienceData_title2',
		subtitle: 'audienceData_subtitle2',
	},
	{
		icon: '🎯',
		title: 'audienceData_title3',
		subtitle: 'audienceData_subtitle3',
	},
	{
		icon: '💁‍♀️',
		title: 'audienceData_title4',
		subtitle: 'audienceData_subtitle4',
	},
];

export const audience_email_AboveList = [
	{
		text: 'audienceData_textAbove_text1',
	},
	{
		text: 'audienceData_textAbove_text2',
	},
];
